import "./new.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import { useState } from "react";
import newRequest from "../../context/newRequest";
import {useNavigate} from "react-router-dom";
import {sleep} from "../../services/help";

import useRegions from "../../hooks/useRegions";

const New = ({ inputs, title }) => {
  const [file,
    // setFile
  ] = useState("");
  const [info, setInfo] = useState({});
  const [sending, setSending] = useState("");
  const [regionId, setRegionId] = useState("JABODETABEK");
  const [roleId, setRoleId] = useState(2);
  const { regions } = useRegions();
  const navigate = useNavigate();
  const user = localStorage.getItem("user");

  const handleSelectRegionID = (e) => {
    setRegionId(e.target.value);
  };


  const handleChange = (e) => {
    setInfo((prev) => ({ ...prev, [e.target.id]: e.target.value }));
  };

  const handleClick = async (e) => {
    e.preventDefault();
    try {
      setSending("On Submit")
      const newUsers = {
        ...info,
        region_id: regionId,
        role_id: Number(roleId),
      };
      await sleep(500);
      setSending("Mengirim Submit");
      const res = await newRequest.post("/users", newUsers, {
        headers: user && user.token ? { Authorization: `Bearer ${user.token}` } : {},
      });
      await sleep(500);
      if (res.status === 200) {
        setSending("Submit berhasil");
        await sleep(800);
        navigate(`/users/${info.id}`);
      }
    } catch (err) {
      const errMsg =
        (err.response && err.response.data && err.response.data.errors) ||
        (err.response && err.response.data && err.response.data.message) ||
        err.message ||
        "Gagal submit user";
      setSending(errMsg);
      console.log(err);
    }
  };
  return (
    <div className="new">
      <Sidebar />
      <div className="newContainer">
        <Navbar/>
        <div className="top">
          <h1>{title}</h1>
        </div>
        <div className="bottom">
          <div className="left">
            <img
                src={
                  file
                      ? URL.createObjectURL(file)
                      : "https://icon-library.com/images/no-image-icon/no-image-icon-0.jpg"
                }
                alt=""
            />
          </div>
          <div className="right">
            <form>
              <div className="formInput">
                {inputs.map((input) => (
                    <div className="formInput" key={input.id}>
                      <label>{input.label}</label>
                      <input onChange={handleChange}
                             type={input.type}
                             placeholder={input.placeholder}
                             id={input.id}
                      />
                    </div>
                ))}
                <label className="formInput">Role User</label>
                <select id="roleId" value={roleId} onChange={(e) => setRoleId(Number(e.target.value))}>
                  <option value={2}>Role Customer / User Biasa</option>
                  <option value={1}>Role Admin (Akses Penuh)</option>
                  <option value={99}>Role Superadmin</option>
                </select>
                <label className="formInput">Region Default: JABODETABEK</label>
                <select id="region_id" value={regionId} onChange={handleSelectRegionID}>
                  <option value="">Pilih Region Id</option>
                  {regions.map((reg) => (
                    <option key={reg.id} value={reg.id}>
                      {reg.id} {reg.description ? `(${reg.description})` : ""}
                    </option>
                  ))}
                </select>
              </div>

              <button onClick={handleClick}>Send</button>

            </form>
            {sending && <p className="error">{sending}</p>}
            <br/>
            <br/>
            <br/>
            <br/>
            <br/>
          </div>
        </div>

      </div>
    </div>
  );
};

export default New;
